import { Component, OnInit} from '@angular/core';
import { SubmissionSearchObject, SubmissionSearchUserInfoObject } from '../search-object';
import { SubmissionHistoryService } from '../../../shared/services/submission-history.service';
import { FormControl } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import {DateUtil} from '../date-util';
import * as _moment from 'moment';
import {KpiService} from '../../../shared/services/kpi.service';
import {MatRadioChange} from '@angular/material/radio';

declare var $: any;

const moment = _moment;

@Component({
    selector: 'kpi-search',
    templateUrl: './kpi-search.component.html',
    styleUrls: [ './kpi-search.component.scss' ],
    providers: [
      {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
      {provide: MAT_DATE_FORMATS, useValue: DateUtil.MY_FORMATS}
      ]
})
export class KpiSearchComponent implements OnInit {

    date = new FormControl(moment());
    minDate = new Date(2000, 0, 1);
    maxDate = new Date();
    searchCriteria = new SubmissionSearchObject();
    userSearchInfo = new SubmissionSearchUserInfoObject();
    totalSampleCount: number;

    ngOnInit() {
        this.submissionHistoryService.currentUserInfo.subscribe(message => this.userSearchInfo = message);
        this.kpiService.currentKpiSearchCriteria.subscribe(message => this.searchCriteria = message);
        this.kpiService.currentTotalSampleSearchCount.subscribe(message => this.totalSampleCount = message);
        this.searchCriteria.submissionIdentifierType = 'Submissions';
    }

    constructor(private submissionHistoryService: SubmissionHistoryService, private kpiService: KpiService) {
        this.searchCriteria.submissionIdentifierType = 'Submissions';
    }

    docTypeChange(docTypeRadio: MatRadioChange) {

        if (DateUtil.validateDateTime($( '#startDate' )[0].value) && DateUtil.validateDateTime($( '#endDate' )[0].value)) {
            const startDateTime = $( '#startDate' )[0].value + ' ' + $( '#startTime' )[0].value;
            const endDateTime = $( '#endDate' )[0].value + ' ' + $( '#endTime' )[0].value;
            this.searchCriteria.submissionIdentifierType = docTypeRadio.value;
            if ( docTypeRadio.value!= "Samples" ){
                this.kpiService.triggerKpiSearch(this.searchCriteria, startDateTime.trim(), endDateTime.trim());
            } else {
                this.kpiService.clearSearchResults();
            }
        } else {
            return;
        }
    }

    onSubmitUpdateKpi() {
        if (DateUtil.validateDateTime($( '#startDate' )[0].value) && DateUtil.validateDateTime($( '#endDate' )[0].value)) {
            const startDateTime = $( '#startDate' )[0].value + ' ' + $( '#startTime' )[0].value;
            const endDateTime = $( '#endDate' )[0].value + ' ' + $( '#endTime' )[0].value;
            this.kpiService.triggerKpiSearch(this.searchCriteria, startDateTime.trim(), endDateTime.trim());
        } else {
            return;
        }
    }

    public updateTableDataSearch(search: SubmissionSearchObject): void {
        const startDateTime = $( '#startDate' )[0].value + ' ' + $( '#startTime' )[0].value;
        const endDateTime = $( '#endDate' )[0].value + ' ' + $( '#endTime' )[0].value;
    }

    clear(myForm: any) {
        this.searchCriteria = new SubmissionSearchObject();
        $( '#startDate' )[0].value = ''
        $( '#endDate' )[0].value = ''
        $( '#startTime' )[0].value = ''
        $( '#endTime' )[0].value = ''
        this.searchCriteria.submissionIdentifierType = 'Submissions';
        this.onSubmitUpdateKpi();
    }

    public onStartDateChange(searchValue: string) {
        if (DateUtil.validateDateTime(searchValue) || (searchValue.length === 0)) {
            $( '#startDateFormField' ).removeClass( 'mat-form-field-invalid' )
        } else {
            $( '#startDateFormField' ).addClass( 'mat-form-field-invalid' )
        }
    }

    public onEndDateChange(searchValue: string) {
        if (DateUtil.validateDateTime(searchValue) || (searchValue.length === 0)) {
            $( '#endDateFormField' ).removeClass( 'mat-form-field-invalid' )
        } else {
            $( '#endDateFormField' ).addClass( 'mat-form-field-invalid' )
        }
    }

    public onStartDateSelected() {
        $( '#startDateFormField' ).removeClass( 'mat-form-field-invalid' )
    }

    public onEndDateSelected() {
        $( '#endDateFormField' ).removeClass( 'mat-form-field-invalid' )
    }
}
